import { ApolloLink, split } from '@apollo/client'

import { APOLLO_CLIENT_CONTEXT_ID } from 'Config/apolloClient'

import createAuthLink from './createAuthLink'
import createDatoAuthLink from './createDatoAuthLink'

function createUnifiedAuthLink(): ApolloLink {
  return split(
    operation => operation.getContext()[APOLLO_CLIENT_CONTEXT_ID.Dato] === true,
    createDatoAuthLink(),
    createAuthLink(),
  )
}

export default createUnifiedAuthLink
